<template><div><h1>VUX V2.8.1 released</h1>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul><li>[fix] fix justify class #2545</li>
</ul>
<h2><a href="/en/components/grid.html">Grid</a></h2>
<ul><li>[feature] add prop:show-lr-borders and prop:show-vertical-dividers #2488</li>
</ul>
<h2><a href="/en/components/previewer.html">Previewer</a></h2>
<ul><li>[feature] add event:on-index-change #2505</li>
</ul>
<h2><a href="/en/components/tab.html">Tab</a></h2>
<ul><li>[feature] support prop:scroll-threshold</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[feature] add slot:right-full-height for containing captcha #2475</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] fix style missing #2375</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.8.1 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.8.1-149.vue?26500968